import { render, staticRenderFns } from "./HeroPress.vue?vue&type=template&id=21163b31&scoped=true"
import script from "./HeroPress.vue?vue&type=script&lang=js"
export * from "./HeroPress.vue?vue&type=script&lang=js"
import style0 from "./HeroPress.vue?vue&type=style&index=0&id=21163b31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21163b31",
  null
  
)

export default component.exports